var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinnerWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.10059 26.8995C5.03215 24.8311 3.66358 22.1667 3.18707 19.2805C2.71057 16.3944 3.15008 13.4315 4.44386 10.808C5.73765 8.18442 7.82072 6.03203 10.4005 4.6531C12.9803 3.27417 15.9273 2.73796 18.8274 3.11977C21.7276 3.50159 24.4354 4.78225 26.5704 6.7819C28.7054 8.78155 30.1604 11.3997 30.7311 14.2687C31.3018 17.1377 30.9594 20.1134 29.7522 22.7779C28.5449 25.4424 26.5334 27.6618 24.0001 29.1244",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 29.1244C21.4668 30.587 18.539 31.2193 15.6279 30.9326C12.7168 30.6459 9.9686 29.4545 7.76931 27.5258C5.57003 25.597 4.03012 23.0279 3.36588 20.1791C2.70163 17.3303 2.94641 14.345 4.06584 11.6424C5.18527 8.93989 7.12311 6.65587 9.6072 5.11117C12.0913 3.56646 14.9969 2.83865 17.9158 3.02997C20.8347 3.22129 23.6204 4.32212 25.8817 6.17785C28.1429 8.03358 29.766 10.551 30.5231 13.3765",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerWhite);
export default __webpack_public_path__ + "static/media/spinner-white.f0098a52de98d4757fd936b9042aa791.svg";
export { ForwardRef as ReactComponent };